/* Product page view switch: FPS / Upgrade path (gaming) and What it can run / Upgrade path (AI).
   Inside a [data-up-tabs] section, a [data-up-tab] button shows the [data-up-panel] with the same name and
   hides the others. A [data-up-go] button switches to its tab and scrolls the section into view.
   A link to #upgrade-path opens the upgrade tab. */
(function () {
  function init(root) {
    if (!root || root.__upTabs) return;
    root.__upTabs = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-up-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-up-panel]'));
    if (!panels.length) return;

    function has(name) {
      return panels.some(function (p) { return p.getAttribute('data-up-panel') === name; });
    }
    function show(name) {
      if (!has(name)) return false;
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(t.getAttribute('data-up-tab') === name)); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-up-panel') !== name; });
      return true;
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-up-tab')); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-up-go]'), function (b) {
      b.addEventListener('click', function () {
        if (show(b.getAttribute('data-up-go'))) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (location.hash === '#upgrade-path' && show('up')) {
      requestAnimationFrame(function () { root.scrollIntoView({ block: 'start' }); });
    }
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-up-tabs]'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
